// src/seo/routeMeta.js
/**
 * Mapping of route paths to SEO metadata.
 * Use the same keys as defined in ROUTINGDATA.
 */
export const routeMeta = {
  '/': {
    title: 'Velaivendum - Home',
    description: 'Find jobs, services and government schemes in Tamil Nadu.',
    keywords: 'Tamil Nadu jobs, government jobs, services, job portal',
    type: 'website',
    image: 'https://www.velaivendum.com/default-og-image.jpg',
  },
  '/login': {
    title: 'Login | VelaiVendum Tamil Nadu Job Portal',
    description: 'Login to VelaiVendum to apply for jobs, manage applications, and connect with employers across Tamil Nadu.',
    keywords: 'VelaiVendum Login, Job Portal Login, Tamil Nadu Jobs Login',
    type: 'website',
  },
  '/post-job': {
    title: 'Post a Job - Velaivendum',
    description: 'Employers can post job openings on Velaivendum.',
    keywords: 'post job, employer posting, job advertisement',
    type: 'website',
  },
  '/jobseeker': {
    title: 'Job Seeker - Velaivendum',
    description: 'Explore job listings and apply for positions.',
    keywords: 'job seeker, find jobs, apply jobs, tamil nadu jobs',
    type: 'website',
  },
  '/employer': {
    title: 'Employer Dashboard - Velaivendum',
    description: 'Post jobs and manage employer profile.',
    keywords: 'employer dashboard, post jobs, manage profile, free job posting, tamil nadu employer, free job posting',
    type: 'website',
  },
  '/volunteer': {
    title: 'Volunteer - Velaivendum',
    description: 'Volunteer opportunities and support services.',
    keywords: 'volunteer opportunities, social service, tamil nadu volunteer',
    type: 'website',
  },
  '/mentor': {
    title: 'Mentor - Velaivendum',
    description: 'Mentorship programs and resources.',
    keywords: 'mentor program, mentorship, tamil nadu mentor',
    type: 'website',
  },
  '/termsandcondition': {
    title: 'Terms and Conditions - Velaivendum',
    description: 'Legal terms for using the platform.',
    keywords: 'terms and conditions, legal, velaivendum terms',
    type: 'website',
  },
  '/privacypolicy': {
    title: 'Privacy Policy - Velaivendum',
    description: 'How we handle your personal data.',
    keywords: 'privacy policy, data protection, velaivendum privacy',
    type: 'website',
  },
  // Dynamic routes (e.g., job detail, search) will use the base path for metadata
  '/job/:id': {
    title: 'Job Details - Velaivendum',
    description: 'Detailed view of a specific job posting.',
    keywords: 'job details, job posting, job description',
    type: 'article',
  },
  '/searchpage/:id': {
    title: 'Search Results - Velaivendum',
    description: 'Search results for your query.',
    keywords: 'search results, job search, velaivendum search',
    type: 'website',
  },
  // Add more routes as needed
};
